module.exports = __webpack_public_path__ + "img/hacker-news.e3d12564.svg";